import { createSlice } from "@reduxjs/toolkit";

// Type definitions
export interface LevelData {
    name: string;
    value: string;
    icon: string;
    description: string;
}

export interface LevelState {
    levels: LevelData[];
}

// Hardcoded levels
const LEVELS: LevelData[] = [
    {
        name: "A1",
        value: "1",
        icon: "/assets/img/a1.png",
        description: "I can use simple sentences to talk about myself and my daily life.",
    },
    {
        name: "A2",
        value: "2",
        icon: "/assets/img/a2.png",
        description: "I can talk about my experiences, daily routines, and plans using simple sentences.",
    },
    {
        name: "B1",
        value: "3",
        icon: "/assets/img/b1.png",
        description: "I can express opinions, describe experiences, and give reasons using connected sentences.",
    },
    {
        name: "B2",
        value: "4",
        icon: "/assets/img/b2.png",
        description: "I can discuss a wide range of topics clearly, give detailed opinions, and support my ideas.",
    },
];

const initialState: LevelState = {
    levels: LEVELS,
};

const levelSlice = createSlice({
    name: "level",
    initialState,
    reducers: {},
});

export default levelSlice.reducer;

